export default "__VITE_ASSET__47b4aac4__"